import { render } from "./PedidoDet.vue?vue&type=template&id=6cd1320e&scoped=true"
import script from "./PedidoDet.vue?vue&type=script&lang=js"
export * from "./PedidoDet.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=6cd1320e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd1320e"]])

export default __exports__